import { Button } from '@/components/ui/button';
import { pages } from "@/Environment";
import { ArrowRight } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

export function CTA() {
  return (
    <section className="w-full bg-white py-24">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 rounded-[2.5rem] border border-[rgba(31,76,84,0.12)] bg-[var(--accent-light)]/70 px-8 py-20 text-center shadow-[0_28px_56px_rgba(15,23,42,0.08)]">
        <span className="eyebrow">
          Get started
        </span>
        <h2 className="font-display text-3xl font-semibold !tracking-display text-[var(--text-primary)] md:text-4xl">
          Bring calm, defensible reporting to your next modern slavery statement.
        </h2>
        <p className="max-w-2xl text-lg leading-relaxed text-[var(--text-secondary)]">
          See where your statement falls short and get prioritised actions for the next one.
        </p>
        <Link to={pages.UPLOAD}>
          <Button size="xl">
            Analyze a statement
            <ArrowRight className="h-5 w-5" />
          </Button>
        </Link>
      </div>
    </section>
  )
}
